import InternalAPI from "../../../../../../app/axios"

export default class ReportRepository extends InternalAPI{
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/agent"
        this.endpointV2 = "/v2/agent"
    }

     /**
     *
     * @param param {string}
     * @return {Promise<{data: Blob, err: null}|{data: null, err: ErrorState}>}
     */
      async exportReport(param) {

        try {
            /** @type {AxiosResponse<Blob>} */
            const res = await this.$axios.get(this.endpointV2 + "/export/data?"+param);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response.data)}
        }
    }

     /**
     *
     * @param param {string}
     * @return {Promise<{data: Array<Agent>, err: null}|{data: null, err: ErrorState}>}
     */
      async getPerformance(param) {
        try {
            /** @type {AxiosResponse<Array<Object>>} */
            const res = await this.$axios.get(this.endpointV2 + "/report/performance/data?"+param);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response.data)}
        }
    }
}